<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">
    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-8">
      <div class="vx-row">
        <div
          class="vx-col md:w-1/4 sm:w-1/2 w-full"
          v-if="actor.privilege <= 3"
        >
          <label class="vs-input--label">Select User</label>
          <v-select
            :options="searchList"
            @search="getUsers"
            placeholder="Search..."
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.keyword"
            class="mb-3"
          >
            <template #no-options>{{ noOptionText }}</template>
          </v-select>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Filter</label>
          <v-select
            :options="dateList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.dateOption"
            class="mb-2 md:mb-0"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="vs-input--label">Start Time</label>
          <flat-pickr
            :disabled="disableDate"
            :config="{
              enableTime: true,
              dateFormat: 'Y-m-d H:i',
              maxDate: maxDate,
              time_24hr: true,
              defaultHour: 0
            }"
            style="width: 100%"
            v-model="filter.start_time"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="vs-input--label">End Time</label>
          <flat-pickr
            :disabled="disableDate"
            :config="{
              enableTime: true,
              dateFormat: 'Y-m-d H:i',
              maxDate: maxDate,
              time_24hr: true,
              defaultHour: 23,
              defaultMinute: 59
            }"
            style="width: 100%"
            v-model="filter.end_time"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mt-2">
          <vs-button
            :disabled="loading"
            id="searchBtn"
            style="width: 100%"
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            class="pl-5 mt-1 vs-con-loading__container"
            @click="search"
            >Search</vs-button
          >
        </div>
      </div>
    </vx-card>

    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <vs-button
            v-if="data.length > 0"
            id="exportBtn"
            icon-pack="feather"
            icon="icon-file-text"
            color="success"
            type="gradient"
            class="mb-4 md:mb-0 vs-con-loading__container"
            @click="handleDownload"
            >Export Data</vs-button
          >
        </div>

        <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ page * per_page - (per_page - 1) }} -
              {{
                row_total - page * per_page > 0 ? page * per_page : row_total
              }}
              of {{ row_total }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="updatePerPage(10)">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(25)">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(50)">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(100)">
              <span>100</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(250)">
              <span>250</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(500)">
              <span>500</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(1000)">
              <span>1000</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(10000)">
              <span>10000</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <div class="table-container">
        <el-table
          :data="data"
          :sort-by="sort_by"
          border
          :height="data.length > 0 ? 1200 : 135"
          style="
            width: 100%;
            margin-top: 10px;
            margin-bottom: 10px;
            border-left: 1px solid #ccc;
          "
        >
          <el-table-column
            label="No"
            width="68"
            type="index"
            :index="indexMethod"
          >
          </el-table-column>
          <el-table-column prop="imei" label="Imei" sortable width="160">
          </el-table-column>
          <el-table-column prop="plate" label="Plate" sortable width="150">
          </el-table-column>
          <el-table-column
            prop="device_name"
            label="Device Name"
            sortable
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="driver_name"
            label="Driver Name"
            sortable
            width="200"
          >
          </el-table-column>

          <el-table-column
            prop="speed_limit"
            label="Speed Limit"
            sortable
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="total_violation"
            label="Total Violation"
            sortable
            width="160"
          >
          </el-table-column>
          <el-table-column prop="start" label="Start Time" sortable width="180">
          </el-table-column>
          <el-table-column prop="end" label="End Time" sortable width="180">
          </el-table-column>

          <el-table-column label="Action" fixed="right">
            <template slot-scope="scope">
              <div class="flex">
                <vx-tooltip text="Speed Limit Details" position="top">
                  <vs-button
                    type="border"
                    size="small"
                    icon-pack="feather"
                    icon="icon-list"
                    color="primary"
                    class="mr-2 vs-con-loading__container"
                    @click="detail(scope.row)"
                  ></vs-button>
                </vx-tooltip>
              </div>
            </template>
          </el-table-column>

          <div
            slot="append"
            v-if="data.length < 1 || loading"
            class="table_empty"
          >
            {{ loading ? 'Loading....' : 'No Data Available' }}
          </div>
        </el-table>
        <vs-pagination :total="n_page" v-model="page" goto></vs-pagination>
      </div>
    </div>

    <vs-popup
      class="vs-popup-lg"
      classContent="popup-example"
      :title="popupTitle"
      :active.sync="showPopup"
    >
      <template>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <div class="flex flex-wrap items-center">
              <div class="flex-grow">
                <vs-button
                  v-if="data.length > 0"
                  id="exportBtnDetail"
                  icon-pack="feather"
                  icon="icon-file-text"
                  color="success"
                  type="gradient"
                  class="mb-4 md:mb-0 vs-con-loading__container"
                  @click="handleDownloadDetail"
                  >Export Data</vs-button
                >
              </div>
              <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
                <div
                  class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                >
                  <span class="mr-2"
                    >{{ page_detail * per_page_detail - (per_page_detail - 1) }}
                    -
                    {{
                      row_total_detail - page_detail * per_page_detail > 0
                        ? page_detail * per_page_detail
                        : row_total_detail
                    }}
                    of {{ row_total_detail }}</span
                  >
                  <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="updatePerPageDetail(10)">
                    <span>10</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="updatePerPageDetail(25)">
                    <span>25</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="updatePerPageDetail(50)">
                    <span>50</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="updatePerPageDetail(100)">
                    <span>100</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="updatePerPageDetail(250)">
                    <span>250</span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="updatePerPageDetail(500)">
                    <span>500</span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>

            <div style="display: block; overflow-x: auto; white-space: nowrap">
              <table class="table" style="width: 100%">
                <thead>
                  <tr>
                    <th style="width: 4%">No</th>
                    <th>Imei</th>
                    <th>Plate</th>
                    <th>Device Name</th>
                    <th>Speed</th>
                    <th>Speed Limit</th>
                    <th>Time</th>
                  </tr>
                </thead>
                <tbody v-if="loading_detail">
                  <tr>
                    <td colspan="10" class="text-center">Loading....</td>
                  </tr>
                </tbody>
                <tbody v-else-if="data_detail.length > 0">
                  <tr v-for="(item, index) in data_detail" :key="index">
                    <td>{{ item.no }}</td>
                    <td>{{ item.imei }}</td>
                    <td>{{ item._gps.plate }}</td>
                    <td>{{ item._gps.device_name }}</td>
                    <td>{{ item.speed }}</td>
                    <td>{{ item.speed_limit }}</td>
                    <td>{{ item.time }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="10" class="text-center">No Data Available</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <vs-pagination
              :total="n_page_detail"
              v-model="page_detail"
              goto
            ></vs-pagination>
          </div>
        </div>
        <div class="vx-row mb-5"></div>
      </template>
    </vs-popup>
  </div>
</template>

<style>
[dir='ltr'] .el-table .cell {
  padding-left: 10px;
  padding-right: 10px;
}

.el-table thead {
  color: #ffff;
  font-weight: bold;
}

[dir] .el-table--border::after,
[dir] .el-table--group::after,
[dir] .el-table::before {
  background-color: #ccc;
}

[dir] .el-table th.el-table__cell {
  background-color: #eee;
  font-size: 14px;
  color: #626262;
}

[dir] .el-table tr:active .el-table__cell {
  background-color: rgb(198, 198, 198);
}

[dir] .el-table td.el-table__cell,
[dir] .el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #ccc;
}

[dir] .el-table .ascending .sort-caret.ascending {
  border-bottom-color: #ffff;
}

[dir] .el-table .descending .sort-caret.descending {
  border-top-color: #ffff;
}

.el-table--border .el-table__cell,
[dir='ltr']
  .el-table__body-wrapper
  .el-table--border.is-scrolling-left
  ~ .el-table__fixed {
  border-left: 1px solid #ccc;
  border-top: 1px solid #ccc;
}

[dir] .el-table .el-table__cell {
  padding: 7px 0;
}

.el-table__empty-block {
  display: none !important;
}

.table_empty {
  text-align: center;
  font-size: 13px;
  padding: 10px;
  border-left: 1px solid #ccc;
}

.table_total {
  padding: 10px;
  border-left: 1px solid #ccc;
}
</style>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import FileDownload from 'js-file-download'

export default {
  components: {
    flatPickr,
    vSelect
  },

  data() {
    return {
      data: [],
      token: '',
      action: '',
      loading: false,
      actor: '',
      tempId: 0,

      disableDate: true,
      filter: {
        keyword: '',
        start_time: null,
        end_time: null,
        today: '',
        dateOption: { value: '', label: '-- Select Filter --' }
      },

      filtered: {
        keyword: '',
        start_time: null,
        end_time: null,
        today: '',
        dateOption: { value: '', label: '-- Select Filter --' }
      },

      searchList: [],
      searchListDefault: '',

      dateList: [
        { value: '', label: '-- Select Filter --' },
        { value: 'today', label: 'Today' },
        { value: 'yesterday', label: 'Yesterday' },
        { value: 'define', label: 'Select Date' }
      ],

      page: 1,
      per_page: 1000,
      row_total: 0,
      keyword: '',

      temp_detail: [],
      data_detail: [],
      page_detail: 1,
      per_page_detail: 10,
      row_total_detail: 0,
      loading_detail: false,

      popupTitle: '',
      showPopup: false,

      timer: null,
      notify: 'Server Error',
      today: '',
      yesterday: '',
      twoDaysAgo: '',

      maxDate: '',

      sort_by:
        ({ prop: 'imei', order: 'descending' },
        { prop: 'plate', order: 'descending' },
        { prop: 'device_name', order: 'descending' },
        { prop: 'driver_name', order: 'descending' },
        { prop: 'speed_limit', order: 'descending' },
        { prop: 'total_violation', order: 'descending' },
        { prop: 'start', order: 'descending' },
        { prop: 'end', order: 'descending' }),

      filename: 'Top Ten Overspeed of Driver Report',
      filenameDetail: 'Top Ten Overspeed of Driver Detail',
      autoWidth: true,
      bookType: 'xlsx'
    }
  },

  computed: {
    n_page() {
      return Math.ceil(this.row_total / this.per_page)
    },

    n_page_detail() {
      return Math.ceil(this.row_total_detail / this.per_page_detail)
    },

    dateOption() {
      return this.filter.dateOption ? this.filter.dateOption.value : ''
    },

    noOptionText() {
      return this.keyword ? 'Type to search' : 'No data found'
    }
  },

  watch: {
    page() {
      this.initTable()
    },

    per_page() {
      if (this.page != 1) this.page = 1
      else this.initTable()
    },

    page_detail() {
      this.getDetailData()
    },

    per_page_detail() {
      if (this.page_detail != 1) this.page_detail = 1
      else this.getDetailData()
    },

    temp_detail: {
      handler(val) {
        if (val) {
          this.page_detail = 1
          this.getDetailData()
        }
      },
      deep: true
    },

    dateOption() {
      let today = new Date()
      let yesterday = new Date(today)

      yesterday.setDate(yesterday.getDate() - 1)
      today = this.formatDate(today.toDateString())
      yesterday = this.formatDate(yesterday.toDateString())

      this.disableDate = true
      if (this.dateOption == 'today') {
        this.filter.start_time = this.today + ' 00:00'
        this.filter.end_time = this.today + ' 23:59'
        this.maxDate = this.today + ' 23:59'
      } else if (this.dateOption == 'yesterday') {
        this.filter.start_time = this.yesterday + ' 00:00'
        this.filter.end_time = this.yesterday + ' 23:59'
        this.maxDate = this.yesterday + ' 23:59'
      } else {
        this.filter.start_time = ''
        this.filter.end_time = ''
        this.maxDate = this.today + ' 23:59'
        // this.maxDate = this.twoDaysAgo + ' 23:59'
        this.disableDate = false
      }
    }
  },

  created() {
    let today = new Date()
    let yesterday = new Date(today)
    let twoDaysAgo = new Date(today)

    yesterday.setDate(yesterday.getDate() - 1)
    twoDaysAgo.setDate(twoDaysAgo.getDate() - 2)

    this.today = this.formatDate(today.toDateString())
    this.yesterday = this.formatDate(yesterday.toDateString())
    this.twoDaysAgo = this.formatDate(twoDaysAgo.toDateString())

    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''

    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data
        // this.searchDevice('')
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })
  },

  mounted() {},

  methods: {
    indexMethod(index) {
      return (this.page - 1) * this.per_page + (index + 1)
    },

    updatePerPage(n) {
      this.per_page = n
    },

    updatePerPageDetail(n) {
      this.per_page_detail = n
    },

    formatDate(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [year, month, day].join('-')
    },

    getUsers(search) {
      if (search.length >= 3) {
        if (this.timer) {
          clearTimeout(this.timer)
          this.timer = null
        }

        this.timer = setTimeout(() => {
          this.$http
            .get(
              `${this.$api.endpoint}/tracking/search?keyword=${search}&type=user`,
              {
                headers: {
                  Authorization: `Bearer ${this.token}`
                }
              }
            )
            .then((res) => {
              this.searchList = res.data.message.data
              this.searchListDefault = this.searchList.find((e, i) => {
                return i === 0
              })
            })
            .catch((error) => {
              this.$gf.httpErrorHandler(error)
            })
        }, 1000)
      }
    },

    initTable() {
      this.data = []
      this.loading = true
      this.$http
        .get(`${this.$api.endpoint}/report/top_ten_overspeed_driver`, {
          params: {
            page: this.page,
            per_page: this.per_page,
            start: `${this.filter.start_time}:00`,
            end: `${this.filter.end_time}:00`,
            keyword: this.filter.keyword ? this.filter.keyword.value : ''
          },

          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.loading = false
          this.$vs.loading.close(`#searchBtn > .con-vs-loading`)

          this.row_total = res.data.message.total
          this.data = res.data.message.data

          this.data.map((item, index) => {
            this.data[index].no = index + 1
          })
        })
        .catch((error) => {
          this.$vs.loading.close(`#searchBtn > .con-vs-loading`)
          this.loading = false
          this.$gf.httpErrorHandler(error)
        })
    },

    search() {
      this.loading = true
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#searchBtn',
        scale: 0.45
      })

      this.filtered.device = this.filter.device
      this.filtered.start_time = this.filter.start_time
      this.filtered.end_time = this.filter.end_time

      this.page = 1
      this.initTable()
    },

    detail(data) {
      this.popupTitle = `Detail : ${data.plate}`
      this.showPopup = true
      this.temp_detail = data
    },

    getDetailData() {
      let params = {
        imei: this.temp_detail.imei,
        start: `${this.filter.start_time}:00`,
        end: `${this.filter.end_time}:00`,
        page: this.page_detail,
        per_page: this.per_page_detail,
        speed_limit: this.temp_detail.speed_limit
      }

      this.$http
        .get(`${this.$api.endpoint}/report/top_ten_overspeed_driver/detail`, {
          params,
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.data_detail = res.data.message.data
          this.row_total_detail = res.data.message.total

          this.data_detail.map((item, index) => {
            this.data_detail[index].no =
              (this.page_detail - 1) * this.per_page_detail + (index + 1)
            this.data_detail[index].plate = item._gps.plate
            this.data_detail[index].device_name = item._gps.device_name
          })
        })
        .catch((error) => {
          this.data_detail = []
          this.row_total_detail = 0
          this.$gf.httpErrorHandler(error)
        })
    },

    handleDownload() {
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#exportBtn',
        scale: 0.45
      })

      import('@/vendor/Export2Excel').then((excel) => {
        const tHeader = [
          'No',
          'Imei',
          'Plate',
          'Device Name',
          'Driver Name',
          'Speed Limit',
          'Total Violation',
          'Start Time',
          'End Time'
        ]

        const filterVal = [
          'no',
          'imei',
          'plate',
          'device_name',
          'driver_name',
          'speed_limit',
          'total_violation',
          'start',
          'end'
        ]

        const list = this.data
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.filename,
          autoWidth: this.autoWidth,
          bookType: this.bookType
        })
        this.$vs.loading.close(`#exportBtn > .con-vs-loading`)
      })
    },

    handleDownloadDetail() {
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#exportBtnDetail',
        scale: 0.45
      })

      import('@/vendor/Export2Excel').then((excel) => {
        const tHeader = [
          'No',
          'Imei',
          'Plate',
          'Device Name',
          'Speed',
          'Speed Limit',
          'Time'
        ]
        const filterVal = [
          'no',
          'imei',
          'plate',
          'device_name',
          'speed',
          'speed_limit',
          'time'
        ]

        const list = this.data_detail
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: `${this.filenameDetail}_${this.data_detail[0]._gps.plate}`,
          autoWidth: this.autoWidth,
          bookType: this.bookType
        })
        this.$vs.loading.close(`#exportBtnDetail > .con-vs-loading`)
      })
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === 'timestamp') {
            return parseTime(v[j])
          } else {
            return v[j]
          }
        })
      )
    }
  }
}
</script>
